import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { UserService } from '../user/user.service';
import { catchError, tap } from 'rxjs/operators';
import { LiveChatService } from '../live-chat/live-chat.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserMeResolverService {

  constructor(
    private service: UserService,
    private router: Router,
    public liveChatService: LiveChatService,
  ) {

  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return this.service.getMe(!!route.data.skipUserMeAuth)
      .pipe(
        tap(user => {
          // Segmentio Identify call required here instead of calling just once, because they want to track
          // user details updates.
          this.service.identify(user);

          // If the route data contains the property 'checkDetailsProvided' and the user data resolved
          // doesn't contain any address and/or phone numbers, a redirection to the view to provide those
          // information will happen.
          // This is mainly to prevent that a user start the pet claiming process without having provided
          // those information.
          if (route.data.checkDetailsProvided && !this.service.areDetailsProvidedFor(user)) {
            this.router.navigate(['/account/owner-details']);
          }
        }),
        catchError(err => {
          if (err instanceof HttpErrorResponse && err.status === 401 && route.data.skipUserMeAuth) {
            return of(null);
          }
          return throwError(err);
        })
      );
  }
}
